import React from 'react'
import Close from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Close'
import Screen1 from '@berlitz/streamline-icons/lib/regular/03-Computers-Devices-Electronics/06-Screens/Screen1'
import ConversationChatBubble from '@berlitz/streamline-icons/lib/regular/21-Messages-Chat-Smileys/03-Conversation/ConversationChatBubble'
import { EventTitle, EventWrapper } from './style'
import Spacer from '@berlitz/spacer'
import EventInfo from '@components/InstructorScheduler/EventInfo'
import { Event } from 'react-big-calendar'
import PortalInstructor from '@classes/Instructor'
import { TEventResource } from './interface'

interface IPEvent extends Event {
  resource: TEventResource
}

interface IPCustomEvent {
  event: IPEvent
  Instructor: PortalInstructor
  title: string
  isAdmin: boolean
  onDelete: (resource: TEventResource) => void
}

const CustomEvent: React.FC<IPCustomEvent> = ({ title, event, Instructor, isAdmin, onDelete = () => {} }) => {
  const isF2F = event.resource?.IsF2F
  const isCore = event.resource?.IsCore
  const isPastEvent = event.resource?.isPastEvent(Instructor.CurrentDate)
  const isUnAvailability = event.resource?.IsUnAvailability
  const unAvailabilityStatus = event.resource?.ApprovalStatus
  const learningCenter = event.resource?.LearningCenterName
  const resource = event.resource

  const eventLabel = (
    <EventTitle>
      {!isUnAvailability && (isF2F ? <ConversationChatBubble /> : <Screen1 />)}
      <span>{title}</span>
    </EventTitle>
  )

  return (
    <>
      <Spacer size="xxs" />
      <EventWrapper className={`${!isAdmin && (isCore || isPastEvent) && 'inline'}`}>
        {(isAdmin || !isCore) && !isPastEvent ? (
          <>
            {eventLabel}
            {resource?.isDeletable(Instructor, isAdmin) && (
              <div
                className="close"
                onClick={() => {
                  onDelete(resource)
                }}
              >
                <Close />
              </div>
            )}
          </>
        ) : (
          eventLabel
        )}
      </EventWrapper>
      {isUnAvailability && <span className="desc">({unAvailabilityStatus})</span>}
      <Spacer size="xxs" />
      {learningCenter && !isUnAvailability && <div>({learningCenter})</div>}
      <EventInfo resource={resource} />
    </>
  )
}

export default CustomEvent
